/**
 * DataFlow Monitor — 공유 타입 (SPEC §4).
 * 서버(API)·클라이언트(store/UI) 모두 이 파일만 import 한다.
 */
export const ALL_NODE_STATUSES = [
    "healthy",
    "running",
    "warning",
    "error",
    "recovering",
    "offline",
];
export const ALL_NODE_TYPES = [
    "source",
    "processor",
    "model",
    "storage",
    "output",
];
